import { render, staticRenderFns } from "./DashboardSecondaryEvents.vue?vue&type=template&id=0153830f"
import script from "./DashboardSecondaryEvents.vue?vue&type=script&lang=js"
export * from "./DashboardSecondaryEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports